import { render, staticRenderFns } from "./DedicatedCustomers.vue?vue&type=template&id=1d59b50e&scoped=true"
import script from "./DedicatedCustomers.vue?vue&type=script&lang=js"
export * from "./DedicatedCustomers.vue?vue&type=script&lang=js"
import style0 from "./DedicatedCustomers.vue?vue&type=style&index=0&id=1d59b50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d59b50e",
  null
  
)

export default component.exports